// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as FilePicker from "../../primitives/FilePicker.res.js";
import * as SliderTrack from "../../resources/layout-and-structure/SliderTrack.res.js";
import * as OrderCavavin from "./OrderCavavin.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as OrderCsvImporting from "./OrderCsvImporting.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";

function OrderCartActionsBar(props) {
  let cartDispatch = props.onRequestDispatch;
  let onRequestSupplierProducts = props.onRequestSupplierProducts;
  let onRequestGlobalFeeModalOpen = props.onRequestGlobalFeeModalOpen;
  let onRequestProductPickerModalOpen = props.onRequestProductPickerModalOpen;
  let onRequestCartLoading = props.onRequestCartLoading;
  let onRequestFileImport = props.onRequestFileImport;
  let onRequestCartRowsError = props.onRequestCartRowsError;
  let importedCsv = props.importedCsv;
  let supplierVariantsCount = props.supplierVariantsCount;
  let supplierId = props.supplierId;
  let shopId = props.shopId;
  let cartProducts = props.cartProducts;
  let authState = Auth.useState();
  let notifier = Notifier.use(undefined, undefined);
  let client = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let captureEvent = SessionTracker.useCaptureEvent();
  let hasCavavinPermission;
  if (typeof authState !== "object" || authState.TAG === "Logging") {
    hasCavavinPermission = false;
  } else {
    let match = authState._0;
    let match$1 = match.user;
    hasCavavinPermission = Auth.hasCavavinPermission(match$1.username, match$1.organizationName, match.shops);
  }
  React.useEffect(() => {
    if (importedCsv !== undefined) {
      OrderCsvImporting.make(importedCsv, client, notifier, hasCavavinPermission, cartProducts, cartDispatch, onRequestCartLoading);
    }
  }, [importedCsv]);
  let supplierProductsButtonDisabled = supplierId === "" || supplierVariantsCount > 50;
  let supplierProductsButtonTooltipText = supplierId !== "" && supplierVariantsCount > 50 ? I18n.template(I18n.t("{{supplierVariantsCount}} products are to be imported,\nthe order may be too large (maximum {{supplierVariantsCountLimit}} products).\nPlease use the product picker to select manually the products you need."), {
      supplierVariantsCount: I18n.decimalFormat(undefined, undefined, undefined, undefined, supplierVariantsCount),
      supplierVariantsCountLimit: I18n.decimalFormat(undefined, undefined, undefined, undefined, 50)
    }, undefined) : undefined;
  return JsxRuntime.jsxs(Inline.make, {
    children: [
      JsxRuntime.jsx(Button.make, {
        label: I18n.t("Search product"),
        variant: {
          NAME: "ghost",
          VAL: {
            bordered: true
          }
        },
        tone: "brand",
        icon: "search",
        onPress: () => onRequestProductPickerModalOpen(true)
      }),
      JsxRuntime.jsxs(SliderTrack.make, {
        children: [
          hasCavavinPermission ? JsxRuntime.jsx(Button.make, {
              label: I18n.t("Send to kviste"),
              variant: "subtle",
              disabled: cartProducts.length === 0,
              icon: "export",
              onPress: () => {
                captureEvent("order_cart_send_to_kviste");
                OrderCavavin.checkProductDataKvisteAPI(cartProducts, shopId, notifier, onRequestCartRowsError, onRequestCartLoading);
              }
            }) : null,
          JsxRuntime.jsx(Tooltip.make, {
            children: JsxRuntime.jsx(Button.make, {
              label: I18n.t("Add supplier's products"),
              variant: "subtle",
              disabled: supplierProductsButtonDisabled,
              icon: "plus_small",
              onPress: () => onRequestSupplierProducts()
            }),
            placement: "top",
            offset: -10,
            content: JsxRuntime.jsx(Tooltip.Span.make, {
              text: Stdlib_Option.getOr(supplierProductsButtonTooltipText, "")
            }),
            disabled: Stdlib_Option.isNone(supplierProductsButtonTooltipText),
            grow: true,
            delay: 350,
            closeDelay: 0
          }),
          JsxRuntime.jsx(Button.make, {
            label: I18n.t("order_cart.actions_bar.allocation_of_costs.text_button"),
            variant: "subtle",
            disabled: cartProducts.length <= 0,
            icon: "plus_small",
            onPress: () => onRequestGlobalFeeModalOpen(true)
          }),
          JsxRuntime.jsx(FilePicker.make, {
            children: JsxRuntime.jsx(Button.make, {
              label: I18n.t("Import csv"),
              variant: "subtle",
              disabled: shopId === "",
              icon: "import"
            }),
            types: [
              "csv",
              "excel"
            ],
            disabled: shopId === "",
            onChange: file => onRequestFileImport(file),
            onError: msg => notifier.reset({
              TAG: "Error",
              _0: msg
            }, undefined, undefined)
          }, importedCsv)
        ],
        compact: true,
        gap: "none"
      })
    ],
    space: "normal"
  });
}

let make = React.memo(OrderCartActionsBar, (oldProps, newProps) => {
  if (oldProps.cartProducts === newProps.cartProducts && oldProps.importedCsv === newProps.importedCsv && oldProps.shopId === newProps.shopId && oldProps.supplierId === newProps.supplierId) {
    return oldProps.supplierVariantsCount === newProps.supplierVariantsCount;
  } else {
    return false;
  }
});

let supplierVariantsCountLimit = 50;

export {
  supplierVariantsCountLimit,
  make,
}
/* make Not a pure module */
